"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updatePrintableDesign;
const layers_1 = require("../../helpers/HAMMER/layers/");
const EditableTextLayer_1 = require("../../models/layers/EditableTextLayer");
const Printable_1 = require("../../models/printables/Printable");
const Template_1 = require("../../models/Template");
const either_1 = require("../../types/either");
// Local imports
const getBookInteriorPageCount_1 = __importDefault(require("./getBookInteriorPageCount"));
const findPrintableGroup_1 = require("./findPrintableGroup");
const layers_2 = require("../layers");
const printables_1 = require("../printables");
const getTemplateSurface_1 = require("../printables/getTemplateSurface");
const getNeedsDependsOnUpdate_1 = require("./updateHelpers/getNeedsDependsOnUpdate");
/**
 * TODO: Refactor this code and make sure it's well tested EN-8857
 * @param project
 * @param action
 * @param template
 * @param ART
 * @returns
 */
function updatePrintableDesign(project, action, template, ART) {
  const printable = (0, findPrintableGroup_1.findPrintableInProject)(project, action.printableId);
  if (!printable) {
    return (0, either_1.left)(new Error(`Printable with id ${action.printableId} not found`));
  }
  const printableGroupIdx = project.printableGroups.findIndex(pg => pg.id === action.printableGroupId);
  const printableGroupType = project.printableGroups[printableGroupIdx].type;
  const printableIdx = project.printableGroups[printableGroupIdx].printables.findIndex(p => p.id === action.printableId);
  let newPrintable;
  let newDesignId = action.designId;
  let isCompositeDesign = false;
  // The steps necessary to update the printable are different for cover printables
  if (project.printableGroups[printableGroupIdx].type === 'cover') {
    if (!(0, Template_1.isTemplateOriginal)(template)) {
      return (0, either_1.left)(new Error('Could not update cover printable: Unsupported template schema version'));
    }
    const interiorPageCount = (0, getBookInteriorPageCount_1.default)(project.printableGroups, project.product.hammerCategory || 'books');
    // This calls updateVersionForModel, so newPrintable has version incremented in this block as well
    const updateBookCoverPrintableResult = (0, printables_1.updateBookCoverPrintable)(template, printable, interiorPageCount, action.timestamp, newDesignId, project.product.hammerCategory);
    if (updateBookCoverPrintableResult.isLeft()) {
      return (0, either_1.left)(updateBookCoverPrintableResult.value);
    }
    newPrintable = updateBookCoverPrintableResult.value;
  } else {
    newPrintable = (0, Printable_1.updatePrintableVersion)(printable, action.timestamp);
    const getNewPrintableLayersResult = (0, layers_1.getNewPrintableLayers)(action, newPrintable.layers, template, printableGroupType);
    if (getNewPrintableLayersResult.isLeft()) {
      return (0, either_1.left)(getNewPrintableLayersResult.value);
    }
    let {
      mergedLayers: templateLayers
    } = getNewPrintableLayersResult.value;
    isCompositeDesign = !!getNewPrintableLayersResult.value.isCompositeDesign;
    if (ART.userCanAddText) {
      if (isCompositeDesign) {
        if (action.activePage === layers_2.CoverageType.FULL) {
          templateLayers = templateLayers.filter(l => !(0, EditableTextLayer_1.isEditableTextLayer)(l));
        } else if (action.activePage === layers_2.CoverageType.RIGHT) {
          templateLayers = templateLayers.filter(l => !(0, EditableTextLayer_1.isEditableTextLayer)(l) || !l.id.includes('--SHIFTED'));
        } else {
          templateLayers = templateLayers.filter(l => !(0, EditableTextLayer_1.isEditableTextLayer)(l) || l.id.includes('--SHIFTED'));
        }
      } else {
        templateLayers = templateLayers.filter(l => !(0, EditableTextLayer_1.isEditableTextLayer)(l));
      }
    }
    if (isCompositeDesign) {
      if (action.activePage === layers_2.CoverageType.FULL) {
        newDesignId = `${action.designId}|${action.designId}`;
      } else {
        const compositeDesignIds = printable.designId.split('|');
        const leftDesign = action.activePage === layers_2.CoverageType.LEFT ? action.designId : compositeDesignIds[0];
        const rightDesign = action.activePage === layers_2.CoverageType.RIGHT ? action.designId : compositeDesignIds[1];
        newDesignId = `${leftDesign}|${rightDesign}`;
      }
    }
    // update dependsOn layers if needed
    const optionKeys = Object.keys(project.product.options);
    const existingPrintableLayers = (0, getNeedsDependsOnUpdate_1.layersHaveDependsOn)(newPrintable.layers, optionKeys) ?
    // existing text layers with dependsOn need to be updated before being copied over
    (0, layers_1.resolveDependsOnValuesForLayers)(newPrintable.layers, ART.attributes, project.product.options) : newPrintable.layers;
    const newTemplateLayers = (0, getNeedsDependsOnUpdate_1.layersHaveDependsOn)(templateLayers, optionKeys) ?
    // any new layer will be resolved with dependsOn value before being added to printable
    (0, layers_1.resolveDependsOnValuesForLayers)(templateLayers, ART.attributes, project.product.options) : templateLayers;
    newPrintable.surface = (0, getTemplateSurface_1.getTemplateSurface)({
      template,
      printableGroupType
    });
    newPrintable.layers = (0, layers_2.updatePrintableDesignLayers)({
      oldSurface: printable.surface,
      newSurface: newPrintable.surface,
      workspaceRotatedForPrintable: !!project.printableGroups[printableGroupIdx].rotateWorkspace,
      existingPrintableLayers,
      newTemplateLayers,
      ignoreEditableTextTemplateLayers: project.printableGroups[printableGroupIdx].type === 'interior' && ART.userCanAddText
    });
  }
  // Final printable attribute updates
  newPrintable.designId = newDesignId;
  newPrintable.isCompositeDesign = isCompositeDesign;
  // Put the newly updated printable copy in the appropriate printable group
  project.printableGroups[printableGroupIdx].printables[printableIdx] = newPrintable;
  const updatedEntities = [newPrintable];
  // If the design property is also part of the project product options, we need to update it there too
  if (action.designAttribute && action.designAttributeId && project.product.options[action.designAttribute]) {
    project.product.options[action.designAttribute] = action.designAttributeId;
  }
  updatedEntities.push(project);
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities
  });
}